import { render, staticRenderFns } from "./mailings-badge-state.vue?vue&type=template&id=04fd2091&"
import script from "./mailings-badge-state.vue?vue&type=script&lang=js&"
export * from "./mailings-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports